import React, { useState, useEffect } from "react";
import "./styles.css";

const MourningPopup = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [hasImage, setHasImage] = useState(false);

    useEffect(() => {
        // แสดง popup เมื่อโหลดหน้าเว็บ
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 1000); // แสดงหลังจาก 1 วินาที

        // ตรวจสอบว่ามีรูปภาพหรือไม่
        try {
            require("../../assets/images/mourning/mou-04.jpg");
            setHasImage(true);
        } catch (error) {
            setHasImage(false);
        }

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        // ป้องกันการ scroll เมื่อ popup แสดง
        if (isVisible) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        // Cleanup เมื่อ component unmount
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isVisible]);

    const handleClose = () => {
        setIsVisible(false);
        document.body.style.overflow = 'unset';
    };

    if (!isVisible) return null;

    return (
        <div className="mourning-popup-overlay">
            <div className="mourning-popup-container">
                <button className="mourning-popup-close" onClick={handleClose}>
                    ×
                </button>
                <div className="mourning-popup-content">
                    {hasImage && (
                        <div className="mourning-image-container">
                            <img 
                                src={require("../../assets/images/mourning/mou-04.jpg")} 
                                alt="พระพันปีหลวง" 
                                className="mourning-image"
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MourningPopup;